import React from "react";

const Heading = (props) => {
    return <h1 style={{fontFamily:"PT Serif,serif"}}>{props.heading}</h1>
} 

export default Heading